// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapsed>.when-opened[data-v-3e62d776],:not(.collapsed)>.when-closed[data-v-3e62d776]{display:none}.border-collapse[data-v-3e62d776]{border:0;border-bottom:2px solid #572600}.custom-header[data-v-3e62d776]{margin-top:-2.2em;margin-right:5em}", ""]);
// Exports
module.exports = exports;
